var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 49,
    viewBox: "0 0 112 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.013 24.5L81.945 41.6917L82.1995 42.122L81.945 41.6917C66.5981 50.7694 45.3973 50.7694 30.0504 41.6917L30.0503 41.6917L0.982203 24.5L30.0503 7.30833L30.0504 7.30831C45.3972 -1.76942 66.5934 -1.76946 81.945 7.30833L111.013 24.5Z",
    fill: "#C8CEFF",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9932 17.4535C69.9621 21.345 69.9621 27.6544 64.9932 31.546C60.0243 35.4375 51.9681 35.4375 46.9991 31.546C42.0302 27.6544 42.0302 21.345 46.9991 17.4535C51.9681 13.5619 60.0243 13.5619 64.9932 17.4535Z",
    fill: "#CB6030",
    stroke: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 49,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ef827a85bdab752d357dcdc4e4af2acf.svg";
export { ForwardRef as ReactComponent };